import {mapValues} from 'lodash'
import clsx from 'clsx'
import React, {useContext} from 'react'
import {useLocation} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'

import QuestionBankFilters from './components/filters'
import Questions from './components/questions'
import Footer from './components/footer'
import StandardsSearch from 'teacher/components/standards-search'

const useStyles = makeStyles(questionBankStyles)

export default function SearchAndSelectQuestion(props) {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const location = useLocation()
  const {quizSearch, quizQuestionBank, translate, updateState, sectionName} = context
  const searchingDone = !quizSearch['question-bank']
  const questionsFound = quizQuestionBank.length > 0

  async function handleSearchStandards(filters) {
    return updateState({
      quizStandardFiltersCalls: {$apply: i => i + 1},
      quizStandardFilters: mapValues(filters, v => ({$set: v}))
    })
  }

  const closePath = location.pathname.replace(/\/standards-search.*/, '')

  return (
    <Box className={classes.root} >
      <StandardsSearch open={sectionName == 'standards-search'} closePath={closePath} onSearchStandards={handleSearchStandards} />
      <Box className={classes.filters}>
        <QuestionBankFilters />
      </Box>
      <Box className={classes.container}>
        <Fade in={searchingDone}>
          <Box className={clsx(classes.content, {questionsFound})}>
            {!questionsFound && (<Box className={classes.noQuestionsFound}>{translate('no-questions-found')}</Box>)}
            {questionsFound && (<Questions onSelect={props.onSelect} />)}
          </Box>
        </Fade>
      </Box>
      <Box className={classes.footer}>
        <Footer context={context} />
      </Box>
    </Box>
  )
}

function questionBankStyles() {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    noQuestionsFound: {
      flexGrow: 1,
      backgroundColor: '#f9f9f9',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      justifyContent: 'center',
      fontSize: '28pt',
      color: '#8990a0',
    },
    container: {
      display: 'flex',
      flexGrow: 1,
      overflow: 'hidden',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
      flexGrow: 1,
      '&.questionsFound': {
        padding: '10px 10px 10px 0',
        '&::-webkit-scrollbar': {
          width: 6
        },
        '&::-webkit-scrollbar-track': {
          background: '#fff',
          padding: 2,
        }
      }
    },
    filters: {
      display: 'flex',
      backgroundColor: '#fff',
      borderBottom: 'solid 1px #becfd7',
    },
    footer: {
      display: 'flex',
      borderTop: 'solid 1px #becfd7',
      padding: '10px 16px'
    }
  }
}

